import { calculateSetDeckPoint } from "./calculateSetDeckPoint";
import { setDeckEffects } from "./setDeckEffects";

export default function calculateSetDeckStates(playerInfos) {

    const totalSetDeckPoint = calculateSetDeckPoint(playerInfos);

    const newSetDeckStates = setDeckEffects.map((effect, index) => {
        
        const requiredPoint = effect.point;

        const isAvailable = totalSetDeckPoint >= requiredPoint;

        const currentState = playerInfos.setDeckStates[index] || {};

        return {
            ...currentState,
            isAvailable: isAvailable
        };
    });

    return {
        ...playerInfos,
        setDeckStates: newSetDeckStates
    }
}